import { ClickTrackingValues } from '@/lib/tracking';
import {
  Alignment as HygraphAlignment,
  Link as HygraphLink,
  LinkVariant as HygraphLinkVariant,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { LinkProps, LinkVariant } from '@/components/link';

import { Side } from '@/enums/side';

export default function linkTransformer(
  link: HygraphMaybe<HygraphLink> | undefined
) {
  if (!link) {
    return undefined;
  }

  const trackingValues: ClickTrackingValues = {
    clickTrachingEnabled: link.enableClickTracking || undefined,
    trackingEventName: link.trackingEventName || undefined,
    ctaType: link.ctaType || undefined,
    ctaElement: link.ctaElement || undefined,
    moduleName: link.moduleName || undefined,
  };

  return {
    href: link.href || '',
    openInNewWindow: link.openInNewWindow || undefined,
    icon: link.icon || undefined,
    iconPosition: iconPositionTransformer(link.iconPosition),
    variant: variantTransformer(link.variant__Link),
    children: link.label,
    trackingValues: trackingValues || undefined,
  } as LinkProps;
}

const variantTransformer = (
  variant: HygraphMaybe<HygraphLinkVariant> | undefined
) => {
  switch (variant) {
    case HygraphLinkVariant.Link:
      return LinkVariant.LINK;
    case HygraphLinkVariant.LinkWithPlus:
      return LinkVariant.LINK_WITH_PLUS;
    case HygraphLinkVariant.PrimaryButton:
      return LinkVariant.PRIMARY_BUTTON;
    case HygraphLinkVariant.WhiteButton:
      return LinkVariant.WHITE_BUTTON;
    case HygraphLinkVariant.GrayButton:
      return LinkVariant.GRAY_BUTTON;
  }
};

function iconPositionTransformer(
  iconPosition: HygraphMaybe<HygraphAlignment> | undefined
) {
  return iconPosition === HygraphAlignment.Left
    ? Side.LEFT
    : iconPosition === HygraphAlignment.Right
      ? Side.RIGHT
      : undefined;
}
